import { throwError } from "@/lib/throwError";
import { del, get, put } from "@/services/axiosUitils";
import {
  CreateTenantProfilePayload,
  TenantProfile,
} from "@/utils/types/tenantProfile";
const tenantProfilesBase = "/api/tenant-core/tenant-profile/";

interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

class TenantProfileService {
  listTenantProfiles = async (
    page = 1,
    pageSize = 20
  ): Promise<PaginatedResponse<TenantProfile>> => {
    console.log(tenantProfilesBase, "tenantProfilesBase");
    return await get<PaginatedResponse<TenantProfile>>(tenantProfilesBase, {
      params: { page, page_size: pageSize },
    });
  };

  getTenantProfileById = async (id: string): Promise<TenantProfile> => {
    if (!id) {
      throwError("ID is required", "TenantProfileService");
    }
    return await get<TenantProfile>(`${tenantProfilesBase}${id}/`);
  };

  createTenantProfile = async (
    payload: CreateTenantProfilePayload
  ): Promise<TenantProfile> => {
    if (!payload) {
      throwError("Payload is required", "TenantProfileService");
    }
    return await put<TenantProfile>(tenantProfilesBase, payload);
  };

  //   updateTenantProfile = async (
  //     id: string,
  //     payload: UpdateTenantProfilePayload
  //   ): Promise<TenantProfile> => {
  //     if (!id || !payload) {
  //       throwError("ID and payload are required", "TenantProfileService");
  //     }
  //     return await put<TenantProfile>(`${tenantProfilesBase}${id}/`, payload);
  //   };

  deleteTenantProfile = async (id: string): Promise<any> => {
    if (!id) {
      throwError("ID is required", "TenantProfileService");
    }
    return await del(`${tenantProfilesBase}${id}/`);
  };

  //   assignPermissionToTenantProfile = async (
  //     roleId: string,
  //     payload: AssignPermissionPayload
  //   ): Promise<any> => {
  //     if (!roleId || !payload) {
  //       throwError("Role ID and payload are required", "TenantProfileService");
  //     }
  //     return await post(`${tenantProfilesBase}${roleId}/assign_permission/`, payload);
  //   };
}

const instance = new TenantProfileService();
export default instance;
